import { Keys, Scene } from "excalibur";
import { goToScene } from "../../main";
import { gameState } from "../../state/stateManager";
import { Resources } from "../../Resources";

export default class OnlineMarket extends Scene {
  constructor() {
    super();
    this.menuItems = 5;
    this.activeItem = 0;
  }
  onActivate() {
    this.marketWindow = document.getElementById("online-market");
    this.marketWindow.style.display = "flex";
    let indication = document.getElementById("hive-indication");
    indication.style.display = "none";
    this.feeding = document.getElementById("feeding");
    this.boxes = document.getElementById("hive-boxes");
    this.bees = document.getElementById("bees");
    this.treatments = document.getElementById("treatments");
    this.honey = document.getElementById("honey-equipment");
    this.coins = gameState.getCoins();
    this.marketCoins = document.getElementById("market-coins");
    this.marketCoins.innerHTML = `<p>Coins: $${this.coins}</p>`;
    this.feeding.classList.add("activeProduct");
  }
  onDeactivate() {}
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      this.marketWindow.style.display = "none";
      goToScene("house", { x: 8, y: 6 });
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Left)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = 4;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    } else if (this.engine.input.keyboard.wasPressed(Keys.Right)) {
      Resources.Click.play();
      if (this.activeItem === 4) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    } else if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      Resources.Inventory.play();
      switch (this.activeItem) {
        case 0:
          goToScene("buySugar");
          break;
        case 1:
          goToScene("buyBoxes");
          break;
        case 2:
          goToScene("buyBees");
          break;
        case 3:
          goToScene("buyTreatments");
          break;
        case 4:
          goToScene("buyHoneyEquipment");
          break;
        default:
          break;
      }
    }

    this.showCorrectProduct();
  }
  showCorrectProduct() {
    switch (this.activeItem) {
      case 0:
        //feeding
        this.feeding.classList.add("activeProduct");
        this.boxes.classList.remove("activeProduct");
        this.bees.classList.remove("activeProduct");
        this.treatments.classList.remove("activeProduct");
        this.honey.classList.remove("activeProduct");
        break;
      case 1:
        //boxes
        this.feeding.classList.remove("activeProduct");
        this.boxes.classList.add("activeProduct");
        this.bees.classList.remove("activeProduct");
        this.treatments.classList.remove("activeProduct");
        this.honey.classList.remove("activeProduct");
        break;
      case 2:
        //bees
        this.feeding.classList.remove("activeProduct");
        this.boxes.classList.remove("activeProduct");
        this.bees.classList.add("activeProduct");
        this.treatments.classList.remove("activeProduct");
        this.honey.classList.remove("activeProduct");
        break;
      case 3:
        //treatments
        this.feeding.classList.remove("activeProduct");
        this.boxes.classList.remove("activeProduct");
        this.bees.classList.remove("activeProduct");
        this.treatments.classList.add("activeProduct");
        this.honey.classList.remove("activeProduct");
        break;
      case 4:
        //honey equipment
        this.feeding.classList.remove("activeProduct");
        this.boxes.classList.remove("activeProduct");
        this.bees.classList.remove("activeProduct");
        this.treatments.classList.remove("activeProduct");
        this.honey.classList.add("activeProduct");
        break;
      default:
        break;
    }
  }
}
